import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';

// Deliberately silent: no tooltip or title.
// The red tint is a translucent wash of the theme's error colour, so it reads in both
// light and dark mode without the full-strength red the Cancelled chip uses.
export const ForcedAssignmentChip = () => (
  <Chip
    label="Forced"
    size="small"
    variant="outlined"
    icon={<LockPersonOutlinedIcon />}
    data-testid="forced-assignment-chip"
    sx={{
      backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
      borderColor: (theme) => alpha(theme.palette.error.main, 0.5),
    }}
  />
);
